export default {
  newsletterLogs: []
}
